import { call, put, takeEvery } from "redux-saga/effects"

import {

  GET_USER_AGREEMENTS

} from "./actionTypes"

import {

  getUserAgreementsSuccess,
  userAgreementsApiError

} from "./actions"

import {
  getUserAgreementsList
} from "../../../helpers/backend_helper/backend_helper"

import { toast,Zoom } from "react-toastify";
import i18n from 'i18n';

function* fetchUserAgreements() {
  try {
    const response = yield call(getUserAgreementsList)
    yield put(getUserAgreementsSuccess(response))
    //toast.success(i18n.t('successful'), { autoClose: 2000, position: toast.POSITION.BOTTOM_LEFT, transition: Zoom });
  } catch (error) {
    yield put(userAgreementsApiError(error))
  }
}

function* userAgreementManagementSaga() {
  yield takeEvery(GET_USER_AGREEMENTS,fetchUserAgreements)
}

export default userAgreementManagementSaga